import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'
import { getImageLink } from 'voting/helpers'


const setFetching = (isFetching) => {
  return reducers.voting.projectPage.setFetching(isFetching)
}

const fetch = () => {
  return request.get(constants.voting.getPoll)
    .then(({ data }) => data)
    .then((poll) => reducers.voting.projectPage.setPoll(poll))
    .catch((error) => {
      console.log({ error })
    })
}

const vote = ({ answerId, questionId }) => {
  return request.post(constants.voting.setVote + `?questionId=${questionId}&entityId=${answerId}`, {})
    .then(({ data }) => data)
    .catch((error) => {
      console.log({ error })
    })
}

const getVotesCount = (questionId) => {
  const {
    me: { id },
  } = getState()

  return request.get(constants.voting.getVote + `?questionId=${questionId}&currentUser=${id}`)
    .then(({ data }) => data)
    .then((count) => reducers.voting.projectPage.setVotesCount({ questionId, count }))
    .catch((error) => {
      console.log({ error })
    })
}

const getPeopleVotesCount = (pollId) => {
  const {
    me: { id },
  } = getState()

  return request.get(constants.voting.getPeopleVotesCount + `?pollId=${pollId}`)
    .then(({ data }) => data)
    .then((count) => reducers.voting.projectPage.setPeopleVotesCount({ pollId, count: count[pollId] }))
    .catch((error) => {
      console.log({ error })
    })
}


export default {
  setFetching,
  fetch,
  vote,
  getVotesCount,
  getPeopleVotesCount,
}
